import { Link } from '@tanstack/react-router'
import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'

const NotFoundPage = () => {
  const { t } = useTranslation()

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-8 px-4 text-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <div className="rounded-full bg-red-100 p-4 dark:bg-red-900/20">
          <AlertTriangle className="h-12 w-12 text-red-600 dark:text-red-500" />
        </div>
        <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl">{t('404Page.title')}</h1>
        <p className="max-w-[600px] text-gray-500 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed dark:text-gray-400">
          {t('404Page.description')}
        </p>
      </div>
      <div className="flex gap-4">
        <Button asChild variant="default">
          <Link to="/">{t('404Page.goHomeButton')}</Link>
        </Button>
      </div>
    </div>
  )
}

export default NotFoundPage
